module.exports = __webpack_public_path__ + "static/media/beata.4b76ce8f.png";